export const ATTACHMENTS_TABLE_HEADERS = [
  "Type",
  "Date",
  "Uploaded by",
  "PI validity",
  "Action",
];
